<template>
  <section class="app-tutolar-wapper">
    <CommonDocumentMenuPage
      v-if="homepageList"
      class="app-tutorial-menu-page"
      :prefix-path="`/${$route.params.lang}/tutorial/${$route.params.category}`"
      :config="homepageList"
    />
    <CommonDocumentMain v-else :prefix-path="`/${$route.params.lang}/tutorial/${$route.params.category}`" />
  </section>
</template>
<script lang="ts" setup>
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-detail-page-cache-tag'])
})
definePageMeta({
  pageTransition: {
    name: '',
    mode: 'out-in'
  }
})

const route = useRoute()
const documentStore = useDocumentStore()
const { fetchDocumentDetail } = documentStore
const { tutorialHomeList } = storeToRefs(documentStore)
const homepageList = computed(() => {
  const id = route.params.id as string
  return tutorialHomeList.value[id]
})
/* document's p4-id === `${homepage_id}-${tutorial_id} */
if (route.params.id.includes('-')) {
  await fetchDocumentDetail(route.params.id as string, 'tutorial')
}
</script>
<style lang="scss" scoped>
.app-tutorial-menu-page {
  @apply w-full pb-13 max-lg:px-5 max-2xl:pl-6 ltr:2xl:pl-10 ltr:max-lg:pl-0 rtl:2xl:pr-10;
}

.app-tutolar-wapper {
  @apply flex;
}
</style>
